import NumberFormats from "components/NumberFormats";
import React from "react";
import { Typography } from "@mui/material";

function WrapperInventoryAvailableNow({ data }) {
  return (
    <Typography
      variant="h6"
      fontWeight={600}
      color={
        data.valueEnd > 0
          ? "success.main"
          : data.valueEnd < 0
          ? "error.main"
          : "text.main"
      }
    >
      {data.valueEnd > 0 && "+"}
      <NumberFormats value={data.valueEnd} />
    </Typography>
  );
}

export default WrapperInventoryAvailableNow;
